import { render, staticRenderFns } from "./projektmanagement-1-4.vue?vue&type=template&id=34b23905&"
import script from "./projektmanagement-1-4.vue?vue&type=script&lang=js&"
export * from "./projektmanagement-1-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports